type SingleEventArgs = Array<unknown>;
type SingleEventCallback = (...args: SingleEventArgs) => void;
export interface SingleEventHandlerInterface {
  trigger(...args: SingleEventArgs): void;
  listen(callback: SingleEventCallback): void;
  stopListening(): void;
}
const SingleEventHandler = (): SingleEventHandlerInterface => {
  let savedArgs: SingleEventArgs | undefined | null;
  let savedCallback: SingleEventCallback | undefined | null;
  return {
    trigger(...args) {
      if (!savedCallback) {
        savedArgs = args;
      } else {
        savedCallback(...args);
      }
    },
    listen(callback) {
      if (savedArgs) {
        callback(...savedArgs);
        savedArgs = null;
      }
      savedCallback = callback;
    },
    stopListening() {
      savedArgs = null;
      savedCallback = null;
    },
  };
};

export default SingleEventHandler;
